const FoodPreference = Object.freeze({
  ALLERGY: 'allergy',
  VEGETARIAN: 'vegetarian',
  VEGAN: 'vegan',
  GLUTEN_FREE: 'gluten_free',
  AVOID_ALCOHOL: 'avoid_alcohol',
  OTHER_PREFERENCE: 'other_preference',
} as const);

export type FoodPreference =
  (typeof FoodPreference)[keyof typeof FoodPreference];

export const allFoodPreferences: [FoodPreference, ...FoodPreference[]] =
  Object.values(FoodPreference) as [FoodPreference, ...FoodPreference[]];

export default FoodPreference;
